import { FilterSelect } from '../../FilterSelect';

export function ProductFilterSelect(props) {
	const {
		value,
		options,
		parentSelection,
		availableText,
		unavailableText,
		onOptionChange,
	} = props;
	const disabled = !parentSelection || options.length === 0;
	return (
		<FilterSelect
			onOptionChange={onOptionChange}
			placeholder={disabled ? unavailableText : availableText}
			value={value}
			options={options}
			required={true}
			filterable={true}
			disabled={disabled}
			{...props}
		/>
	);
}
